/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Button, Spacer, Link } from '@zapier/design-system';
import { urlWithNext } from '@zapier/url-utils';
import Surface from '@zapier/product-get-help/esm/components/shared/Surface';
const gridCss = css `
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 0.3fr 0.3fr 1fr;
`;
const gridChildCss = css `
  justify-self: end;
  align-self: center;
`;
/**
 * Renders the login block.
 */
const LoginBlock = ({ onClickLogIn, onClickSignUp, onClickContinue, size = 'large', }) => {
    const next = `${window.location.pathname}${window.location.search}`;
    return (jsx(Surface, { backgroundColor: "neutral100", size: size, title: "Log in for better support!" },
        jsx("p", null, "Logging in with your Zapier account will give our support system access to specific Zaps and Developer integrations so we can help you faster."),
        jsx(Spacer, { height: 13 }),
        jsx("div", { css: gridCss },
            jsx(Button, { color: "primary", href: urlWithNext('/app/login', next), onClick: onClickLogIn, size: "small" }, "Log in"),
            ' ',
            jsx(Button, { color: "secondary", href: urlWithNext('/sign-up/', next), onClick: onClickSignUp, size: "small" }, "Sign Up"),
            jsx("div", { css: gridChildCss },
                jsx(Link, { onClick: onClickContinue, weight: "normal" }, "Continue without logging in")))));
};
export default LoginBlock;
